<div class="testimonials-wrapper">
  <div class="testimonials-column">
    <div class="testimonial"
         *ngFor="let testimonial of testimonials">
      <div class="testimonial-quote">
        <div class="testimonial-bigquote">
          <img src="assets/big_quote.svg"/>
        </div>
        <span [innerHTML]="testimonial.quote">
        </span>
      </div>
      <div class="testimonial-author">
        {{testimonial.author}}
      </div>
    </div>
  </div>
</div>
